// ThemeContext.tsx
import React, { createContext, useContext, useState, ReactNode, useLayoutEffect } from 'react';
import { ITheme, defaultTheme } from '../common/theme/types/theme.type';
import { lightTheme } from '../common/theme/types/light-theme.type';
import { darkTheme } from '../common/theme/types/dark-theme.type';
import setCSSVariables from '../common/theme/setCSSVariables';

interface ThemeContextProps {
  theme: ITheme;
  setTheme: (theme: ITheme) => void;
}

const ThemeContext = createContext<ThemeContextProps>({
  theme: lightTheme,
  setTheme: theme => console.warn('No Theme Provider found.')
});

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<ITheme>(lightTheme);

  useLayoutEffect(() => {
     // Aplica el tema cuando cambia
    setCSSVariables(theme);
  }, [theme]);
  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
